import { makeAutoObservable, observable } from 'mobx';

class ImageViewStore {
	@observable isOpen = false;
	scale = 1;
	images = null;

	constructor(props) {
		makeAutoObservable(this);
		this.images = props.images;
	}

	openModal() {
		this.isOpen = true;
		this.scale = 1; // reset zoom
	}

	closeModal() {
		this.isOpen = false;
		this.scale = 1;
	}

	zoomIn() {
		this.scale = Math.min(this.scale + 0.25, 3); // max zoom 3x
	}

	zoomOut() {
		this.scale = Math.max(this.scale - 0.25, 0.5); // min zoom 0.5x
	}

	resetZoom() {
		this.scale = 1;
	}
}

export default ImageViewStore;
